module.exports = __webpack_public_path__ + "static/media/co_cuotas.d2e43a28.png";